import React from "react"
import TextField from "./common/textField"
import { translate } from "../../../../i18n"

export interface ConsiderationsFieldProps {
    childNum: number
    required: boolean
}

const maxLength = 500

const ConsiderationsField: React.FC<ConsiderationsFieldProps> = (props) => {
    const { childNum, required } = props
    return (
        <TextField 
            name={`children.${childNum}.considerations`}
            label={translate("facilityReservationForm.form.label.considerations", maxLength.toString())}
            maxLength={maxLength}
            row={8}
            title={translate("facilityReservationForm.form.label.considerations", maxLength.toString())}
            required={required}
        />
    )
}

export default ConsiderationsField;
